// src/components/Profile.jsx
import React from 'react';
import { profile } from '../data/profileData';
import './profile.css';

const Profile = () => {
  const { name, title, bio, imagePath, ctaText, socials } = profile;

  // Fallback image if user didn't add `public/profile.jpg`
  const fallback = 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=1600&auto=format&fit=crop&ixlib=rb-4.0.3&s=9b3f7926549f8f4a6f3b2de1b8f2a9c7';
  const imgSrc = imagePath || fallback;

  return (
    <section id="home" className="hero">
      <div className="hero__content">
        <div className="hero__media" aria-hidden="true">
          <div className="hero__ring" />
          <img
            className="hero__img"
            src={imgSrc}
            alt={name}
            onError={(e) => (e.currentTarget.src = fallback)}
          />
        </div>

          <div className="hero__text">
            <p className="hello">Hello, I'm</p>
            <h1 className="name">{name}</h1>
            <h2 className="title">{title}</h2>
            <p className="bio">{bio}</p>

            <div className="hero__actions">
              <a href="#projects" className="btn primary">
                {ctaText}
              </a>
              <a 
                href={socials?.github || '#'} 
                className="btn outline"
                target="_blank" 
                rel="noreferrer"
              >
                GitHub
              </a>
            </div>

            <div className="scrollHint" aria-hidden="true">
              <span>Scroll</span>
              <svg 
                width="16" 
                height="24" 
                viewBox="0 0 16 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M7 2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2H7ZM8.41421 22.4142C8.02369 22.8047 7.39052 22.8047 7 22.4142L0.636039 16.0503C0.245515 15.6597 0.245515 15.0266 0.636039 14.636C1.02656 14.2455 1.65973 14.2455 2.05025 14.636L8 20.5858L13.9497 14.636C14.3403 14.2455 14.9734 14.2455 15.364 14.636C15.7545 15.0266 15.7545 15.6597 15.364 16.0503L9 22.4142C8.60948 22.8047 7.97631 22.8047 7.58579 22.4142L8.41421 22.4142ZM7 2V21H9V2H7Z" 
                  fill="currentColor"
                  opacity="0.5"
                />
              </svg>
            </div>
          </div>
      </div>
    </section>
  );
};

export default Profile;
